class UltimateMarquee {
  constructor(container) {
    this.container = container;
    this.wrapper = container.querySelector('.marquee-wrapper');
    
    this.speed = parseFloat(container.dataset.speed) || 1.5;
    this.direction = parseInt(container.dataset.direction) || 1; 
    
    this.x = 0;
    this.targetX = 0;
    this.isDragging = false;
    this.isHovered = false;
    this.startX = 0;
    this.scrollLeft = 0;
    this.trackWidth = 0;
    
    // Mount the floating badge structure safely directly to the document body element
    this.badge = document.createElement('div');
    this.badge.className = 'marquee-swipe-badge';
    this.badge.innerText = 'Swipe';
    document.body.appendChild(this.badge);
    
    this.init();
  }

  init() {
    setTimeout(() => this.updateDimensions(), 50);
    window.addEventListener('resize', () => this.updateDimensions());

    // Run layout looping pipeline tick
    this.tick();

    // 1. Follow Mouse logic tracking relative to viewport window coordinates
    window.addEventListener('mousemove', (e) => {
      if (this.isHovered && this.badge) {
        this.badge.style.left = `${e.clientX}px`;
        this.badge.style.top = `${e.clientY}px`;
      }
    });

    this.container.addEventListener('mouseenter', () => {
      this.isHovered = true;
      this.badge.classList.add('is-visible');
    });

    this.container.addEventListener('mouseleave', () => {
      this.isHovered = false;
      this.badge.classList.remove('is-visible');
      this.endDrag();
    });

    // 2. Click & Drag Processing
    this.container.addEventListener('mousedown', (e) => this.startDrag(e.pageX));
    window.addEventListener('mousemove', (e) => {
      if (this.isDragging) this.dragMove(e.pageX);
    });
    window.addEventListener('mouseup', () => this.endDrag());

    // 3. Touch Screen Gesture Support
    this.container.addEventListener('touchstart', (e) => {
      this.isHovered = true; 
      this.startDrag(e.touches[0].pageX);
    }, { passive: true });
    
    this.container.addEventListener('touchmove', (e) => {
      if (this.isDragging) this.dragMove(e.touches[0].pageX);
    }, { passive: true });
    
    this.container.addEventListener('touchend', () => {
      this.isHovered = false;
      this.endDrag();
    });
  }

  updateDimensions() {
    const tracks = this.wrapper.querySelectorAll('.marquee-track');
    if (!tracks.length) return;
    this.trackWidth = tracks[0].getBoundingClientRect().width;
  }

  startDrag(xPosition) {
    this.isDragging = true;
    this.container.classList.add('grabbing');
    if(this.badge) this.badge.classList.add('is-grabbing');
    this.startX = xPosition;
    this.scrollLeft = this.targetX;
  }

  dragMove(xPosition) {
    if (!this.trackWidth) return;
    const deltaX = xPosition - this.startX;
    this.targetX = this.scrollLeft + deltaX;
  }

  endDrag() {
    this.isDragging = false;
    this.container.classList.remove('grabbing');
    if(this.badge) this.badge.classList.remove('is-grabbing');
  }

  tick() {
    if (!this.trackWidth) {
      requestAnimationFrame(() => this.tick());
      return;
    }

    // Automated scroll updates when user interaction is idle
    if (!this.isDragging && !this.isHovered) {
      this.targetX -= this.speed * this.direction;
    }

    // Dynamic smoothing translation calculations
    const interpolationFactor = this.isDragging ? 0.25 : 0.1;
    this.x += (this.targetX - this.x) * interpolationFactor;

    // Loop normalization reset logic bounds
    const resetPoint = this.trackWidth;
    if (this.x <= -resetPoint) {
      this.x += resetPoint;
      this.targetX += resetPoint;
    } else if (this.x > 0) {
      this.x -= resetPoint;
      this.targetX -= resetPoint;
    }

    this.wrapper.style.transform = `translate3d(${this.x}px, 0, 0)`;
    requestAnimationFrame(() => this.tick());
  }
}

const runMarqueeEngine = () => {
  document.querySelectorAll('.marquee-section').forEach(el => {
    if (!el.hasAttribute('data-marquee-initialized')) {
      el.setAttribute('data-marquee-initialized', 'true');
      new UltimateMarquee(el);
    }
  });
};

window.addEventListener('load', runMarqueeEngine);
document.addEventListener('DOMContentLoaded', runMarqueeEngine);

if (window.shopifyFeatures) {
  document.addEventListener('shopify:section:load', () => setTimeout(runMarqueeEngine, 200));
}